import { Box, Container, Typography } from "@mui/material";
import React from "react";
import scienceOfYoga from "../../images/scienceOfYoga.avif";

const styles = {
  parenBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "40px",
  },
  leftBox: {
    display: "flex",
    alignItems: "start",
    justifyContent: "center",
    flexDirection: "column",
    gap: 3,
    flexWrap: "wrap",
  },
  rightBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  heroTitle: {
    fontFamily: "poppins",
    fontWeight: "bold",
    lineHeight: 1.5,
    opacity: 0.7,
  },
  heroSubtitle: {
    fontFamily: "poppins",
    fontWeight: 600,
    opacity: 0.7,
  },
  button: {
    px: "10px",
    py: "5px",
    fontFamily: "poppins",
    fontSize: "14px",
    textTransform: "none",
    backgroundColor: "#141414FF",
    color: "#ffffff",
  },
};

const YogaHero = () => {
  return (
    <Container maxWidth="lg">
      <Box sx={{ ...styles.parenBox }}>
        <Box sx={{ ...styles.leftBox }}>
          <Typography
            variant="h4"
            textAlign={"start"}
            sx={{ ...styles.heroTitle }}
          >
            The science of Yoga
          </Typography>
          <Typography
            variant="body1"
            textAlign="start"
            sx={{ ...styles.heroSubtitle }}
          >
            Here our body and mind is a continuous communication and communion
            with one another. The body speaks to the mind and vice versa also.
            Thus keeping this basic logic in mind we can approach in two ways
            either first go from the mind to the body or from the body to the
            mind
          </Typography>
        </Box>

        <Box sx={{ ...styles.rightBox }}>
          <Box
            component="img"
            src={scienceOfYoga}
            sx={{ width: "550px", heigh: "550px" }}
          />
        </Box>
      </Box>
    </Container>
  );
};

export default YogaHero;
